// extracted by mini-css-extract-plugin
module.exports = {"cover__radio_icon_1":"SectionCover_cover__radio_icon_1__3Xu7j","cover__radio_icon_2":"SectionCover_cover__radio_icon_2__30So_"};